import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import { intl } from 'di18n-react';
import { useEffect } from 'react';
import { useRequest } from 'ahooks';
import { UserService } from '@/service';
const Cpn = props => {
  const {
    visible,
    setVisible
  } = props;
  const [form] = _Form.useForm();
  const {
    run: getUserCenterRun,
    loading: Loading
  } = useRequest(UserService.getUserCenter, {
    manual: true,
    onSuccess: res => {
      form.setFieldsValue({
        key: res.key,
        secret: res.secret
      });
    }
  });
  const {
    run: postUserAkRefreshRun,
    loading: postUserAkRefreshLoading
  } = useRequest(UserService.postUserAkRefresh, {
    manual: true,
    onSuccess: res => {
      getUserCenterRun();
    }
  });
  useEffect(() => {
    getUserCenterRun();
  }, []);
  return /*#__PURE__*/React.createElement(_Modal, {
    title: "AccessKey",
    visible: visible,
    onCancel: () => {
      setVisible(false);
    },
    footer: /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end gap-5"
    }, /*#__PURE__*/React.createElement(_Button, {
      type: "default",
      onClick: () => {
        setVisible(false);
      }
    }, intl.t('关闭')), /*#__PURE__*/React.createElement(_Button, {
      onClick: () => {
        postUserAkRefreshRun();
      },
      loading: postUserAkRefreshLoading
    }, intl.t('重新生成')))
  }, /*#__PURE__*/React.createElement(_Form, {
    form: form
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    label: "Key",
    field: "key",
    required: true,
    disabled: true
  }, /*#__PURE__*/React.createElement(_Input, null)), /*#__PURE__*/React.createElement(_Form.Item, {
    label: "Secret",
    field: "secret",
    required: true,
    disabled: true
  }, /*#__PURE__*/React.createElement(_Input, null))));
};
export default Cpn;